import { render } from "./PhotoListHome.vue?vue&type=template&id=b6d42c30&ts=true"
import script from "./PhotoListHome.vue?vue&type=script&lang=ts"
export * from "./PhotoListHome.vue?vue&type=script&lang=ts"

import "./PhotoListHome.vue?vue&type=style&index=0&id=b6d42c30&lang=stylus"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__